export default __webpack_public_path__ + "static/media/4.8ac2e4cd.png";